import axios from "axios";
import { toastr } from "react-redux-toastr";
//import { closeModal, openModal } from "./modalAction";

import {
  // appPARAMETER types
  FETCH_PROJECTNAMERESIS_GGN,
  FETCH_PROJECTNAMECOMS_GGN,
  FETCH_LOCALITYS_GGN,
  
} from "./types";

//fetch all ProjectNameResis Dwarka
export const fetchProjectNameResis = () => async (dispatch) => {
  try {
    const res = await axios.post(`/api/ggn/ProjectNameResiList`);

    dispatch({ type: FETCH_PROJECTNAMERESIS_GGN, payload: res.data });
  } catch (error) {
    toastr.error("Oops", "Something went wrong.Please Try Again");
  }
};
// create ProjectNameResi
export const createProjectNameResi = (values) => async () => {
  try {
    const res = await axios.post("/api/ggn/ProjectNameResiCreate", values);
    if (res.data.msg === "errorAlready") {
      toastr.error("Residential Project Name Already Exist Use Another");
    }

    if (res.data.msg === "success") {
      toastr.success("Residential Project Name Created Successfully");
    }
  } catch (error) {
    toastr.error("Oops", "Something went wrong.Please Try Again");
  }
};
//fetch all ProjectNameComs Dwarka
export const fetchProjectNameComs = () => async (dispatch) => {
  try {
    const res = await axios.post(`/api/ggn/ProjectNameComList`);

    dispatch({ type: FETCH_PROJECTNAMECOMS_GGN, payload: res.data });
  } catch (error) {
    toastr.error("Oops", "Something went wrong.Please Try Again");
  }
};
// create ProjectNameCom
export const createProjectNameCom = (values) => async () => {
  try {
    const res = await axios.post("/api/ggn/ProjectNameComCreate", values);
    if (res.data.msg === "errorAlready") {
      toastr.error("Commercial Project Name Already Exist Use Another");
    }

    if (res.data.msg === "success") {
      toastr.success("Commercial Project Name Created Successfully");
    }
  } catch (error) {
    toastr.error("Oops", "Something went wrong.Please Try Again");
  }
};

//fetch all Locality Dwarka
export const fetchLocalitys = () => async (dispatch) => {
  try {
    const res = await axios.post(`/api/ggn/LocalityList`);

    dispatch({ type: FETCH_LOCALITYS_GGN, payload: res.data });
  } catch (error) {
    toastr.error("Oops", "Something went wrong.Please Try Again");
  }
};

// create Locality
export const createLocality = (values) => async () => {
  try {
    const res = await axios.post("/api/ggn/LocalityCreate", values);
    if (res.data.msg === "errorAlready") {
      toastr.error("Locality Name Already Exist Use Another");
    }

    if (res.data.msg === "success") {
      toastr.success("Locality Created Successfully");
    }
  } catch (error) {
    toastr.error("Oops", "Something went wrong.Please Try Again");
  }
};

